import React from 'react'
import { Card } from 'antd'
import IntlMessages from '../../../util/IntlMessages'

const HKHome = (): JSX.Element => (
  <div className="content-wrapper">
    <Card>
      <h1 style={{ textAlign: 'center' }}>
        <IntlMessages id="hk.welcome" />
      </h1>
    </Card>
  </div>
)

export default HKHome
